import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import styles from './styles.module.scss';

const TextLoopSwipeUpAnimation = ({ type, windowSize, texts, loopInterval = 2000, animationDuration = 1 }) => {
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [styleZoom, setStyleZoom] = useState([{
    x: 0,
    y: 100,
  }, {
    x: 0,
    y: 100,
  }, {
    x: 0,
    y: 100,
  }, {
    x: 0,
    y: 100,
  }, {
    x: 0,
    y: 100,
  }]);
  useEffect(() => {
    const textLoopTimer = setTimeout(() => {
      setIsAnimating(true);
      setTimeout(() => {
        setCurrentTextIndex((prevIndex) => (prevIndex + 1) % texts?.length);
        setIsAnimating(false);
      }, animationDuration * 1000);
    }, loopInterval);

    return () => clearTimeout(textLoopTimer);
  }, [currentTextIndex, texts?.length, loopInterval, animationDuration]);

  return (
    type === "team" ? <Swiper
      direction={"vertical"}
      spaceBetween={40}
      loop={true}
      pagination={{
        clickable: false,
      }}
      autoplay={{
        delay: 800,
        disableOnInteraction: false,
      }}
      modules={[Autoplay]}
      className="mySwiper"
      style={{ height: windowSize >= 768 ? 100 : 60, border: "1px solid transparent" }}
    >
      {texts?.map((item, index) => (
        <SwiperSlide key={index} className={styles[`${type}_text_title`]} style={{ color: item.color, marginTop: type == 'team' && -3 }}> {item.title} </SwiperSlide>
      ))}
    </Swiper> :
    <Swiper
    direction={"vertical"}
    spaceBetween={40}
    loop={true}
    pagination={{
      clickable: false,
    }}
    autoplay={{
      delay: 2000,
      disableOnInteraction: false,
    }}
    modules={[Autoplay]}
    className="mySwiper"
    style={{ height: windowSize >= 758 ? 100 : 60, border: "1px solid transparent" }}
  >
    {texts?.map((item, index) => (
      <SwiperSlide key={index} className={styles[`${type}_text_title`]} style={{ color: item.color, marginTop: type == 'team' && -3, pointerEvents: "none" }}> {item.title}</SwiperSlide>
    ))}
  </Swiper>
  );
};

export default TextLoopSwipeUpAnimation;
